
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as labsJqPocXy6kQ1M4Bmt4nLLZwWMCA8T3oUJ1PD37_45ZjYVAMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/labs.vue?macro=true";
import { default as colabWtuhZSpjNlbZIQRWCs1vP89pEi5UjZt4ewd9PszKSk8Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/colab.vue?macro=true";
import { default as error4Zpbsjgl7ExNttg2sWsFlwLy3YACKrpogxX5toKXMfkMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/error.vue?macro=true";
import { default as indexwpwwKeOPi9jKwyq8ba8owN6jxni1TAEV1fruxfWoU0UMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/index.vue?macro=true";
import { default as indexLc9YtEJzuTKvv_45xDLrZbroQM3dwpCARbDjpQAV22C8UMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/launch/index.vue?macro=true";
import { default as indexpTWO8ztUsDNh0_r9yO5yH94S1mDrBEOcnRQuGXHnVRMMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/launch/status/index.vue?macro=true";
import { default as quick_45launch_45statuspRrML4BRu9FO3nuZ4jR0nxBklTnICEfFiFy4s7veEFwMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/launch/quick-launch-status.vue?macro=true";
import { default as launchaYgv1EPRTpWGVNf_45bCplaFkxNSWMQ_SHIPfDqemXFOQMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/launch.vue?macro=true";
import { default as indexntLoiXpwrf3pKVjvAc7Qb7ffcALXSF7rjtbtx1Nm5skMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/manage/index.vue?macro=true";
import { default as _91manageType_93NfbIELIlyk8Uc1l8OZ4n3PEGO6zS6zCWDox6bKMLRP8Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/manage/[manageType].vue?macro=true";
import { default as indexM3M1KrZaLDXv5VbKtULiqeq8V46cxzj5DquwtOgGym4Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/manage/create/index.vue?macro=true";
import { default as managezGi5ibVWesTfZVY4zCxLDns84yRHayjR4vad_qP_4_sMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/manage.vue?macro=true";
import { default as statusP2dOHP82RMarFDYG2gOwJvObPgUcZqAPVQGd0FyymhgMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/status.vue?macro=true";
import { default as api_45docPaB_2WgNauZeMMQ6HUZqoKcLOW33c8Py0iQe2N0X4GoMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/api-doc.vue?macro=true";
import { default as index208QqyuekDA5nmYsYssS07CmM08WYMO5F8wmGu2x7B8Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/welcome/index.vue?macro=true";
import { default as welcomelnDrnErmADE3pBo6pEF2f1bXKDuA_BWfbr9tbDUN3BgMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/welcome.vue?macro=true";
import { default as bulk_45editcNC6BeNHBDAv9JyIwaFvcn3yaGAIlxeZDFZz80zFpm8Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/bulk-edit.vue?macro=true";
import { default as html5_45adsAadkX2ry0gDmIPVSCvTqzx_yWgP5t_45an5Fy_45ZLX2HAQMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/html5-ads.vue?macro=true";
import { default as video_45adsCM0LX_ja8qgk_1ucOKmZ6zudvZd58u8JLoRgstuHpb4Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/video-ads.vue?macro=true";
import { default as indextE_45DYG89SmqBkDWNgZ5Qj76NyAgDUFU29pz5Cj_45bwQ0Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/bulk/index.vue?macro=true";
import { default as deckHelperhshp_MQWDCJyDvHgw_45OizsEIdphfgUiOld3VliRGZqoMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/deckHelper.vue?macro=true";
import { default as indexBrQhsGRqSKY1JhZGNlpQLKB7eu6QVMunpEk14qmqqekMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/login/index.vue?macro=true";
import { default as office_45matelMCNXPc0vfJStKxSed5YOydCkk26YeZcRQwLWNjGx4kMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/office-mate.vue?macro=true";
import { default as index5lCTrZnlNCA_jwnLO7YMd1MN75Ws_45YccAHkesdctZwwMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/setup/index.vue?macro=true";
import { default as index0jQhkP_mzLPQBAaT_45ACHNA4QdUlRMh4QAwxznG2b_45q8Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/style/index.vue?macro=true";
import { default as indexhIc6ZphuxJHOLPCDVxhtbjVmw_45kODT9C6kCGtAi3FDkMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/alerts/index.vue?macro=true";
import { default as indexH6ajeckYzF10zg6FLlXxL5Zx_45_45N5t5QSdUsYksy97MQMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/bionic/index.vue?macro=true";
import { default as receiptr24B5Za73g5i1L42XeUCgRavwP3x5kOyQ11Ezyco1wUMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/bulk/receipt.vue?macro=true";
import { default as form_45designertiZ0dgEzHMkuFn6Gvjmb5yMTuZTdkIWdVrCEhaebg8EMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/form-designer.vue?macro=true";
import { default as logsWvrvuYhx7thXkZK_5ZRln8fiF_45Nthp1hcvjez14mz94Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/logs.vue?macro=true";
import { default as logo_45XxLha193tPS2OBEb5XXAsnET2m67jm5wq_bdcCGuysMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/logo.vue?macro=true";
import { default as vue3GquK0i1xFcOPrcRGCoABimG4RGeeNldYTUxywG_Hh9AMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/vue3.vue?macro=true";
import { default as datavzvOLrO9CdlHUPLJbZoH8NXbaZuovg0aYxQYaD1wRJkMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/settings/data.vue?macro=true";
import { default as bionic2p1g_P4TMFScCHH1Bs6Z7oBkUlYBPGqxuE7FiFAX6pYcMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/bionic/bionic2.vue?macro=true";
import { default as bionic3LrZ6TD4fK2HYgppsKuTT4VFCXMO20OiMu0pDnvzhh0EMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/bionic/bionic3.vue?macro=true";
import { default as bionic4zzmXV_454oDHHLQfeT_45dPM42TEWTboXfL7JH8Z_45dMY_45vkMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/bionic/bionic4.vue?macro=true";
import { default as indexY8j7TzUZrTxpJ0nhSnTW7V6hfl7iLzp3omA06OhdLiQMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/index.vue?macro=true";
import { default as page_45not_45foundhTV0iCL7sjtN0_45EmwxnJqxXCUvABRVkTNFEHF2GW39gMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/page-not-found.vue?macro=true";
import { default as indexh7v8Gj1ZccwdJgZjUEv_457rsIFieYcE8IOAnJzv2RoTIMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/approvals/index.vue?macro=true";
import { default as indexu_z7xdIsD1saPI1yDt6hrKEn5zZy_45BL3urkWDNi1wEkMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/dashboard/index.vue?macro=true";
import { default as indexaiEt87_45XwwL93aK6yDHZpnQEkQMJke76Hh669pTRUCwMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/reporting/index.vue?macro=true";
import { default as _91partner_932Ub2mmF5gN_45S_oG1VK_721JAhJ2sx5iR4G96b23Ii4UMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/setup/[partner].vue?macro=true";
import { default as indexA3e376zqziqoUCZ6BIn_450jPkhnGo5K2gjSVx6BgjpZIMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/blueprints/index.vue?macro=true";
import { default as crawlerJDWIq2aCkJQvCDtPCUCiGqPn9vfbu13TA4L6TZuPwZEMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/crawler.vue?macro=true";
import { default as ai_45helpz5TY71fSpSysAqHoZx1ohoMYV68YXsl67ULH8SSXH0sMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/ai-help.vue?macro=true";
import { default as sandboxFn0Pv8wIfqdN4IqqOqeg37XX26TdlRvcrlKE5aXTVfIMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/sandbox.vue?macro=true";
import { default as fluency9VwTTSknZn0nbpZXWO8CKXiFoyljhR7XnsYrfuoQMzMMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/settings/fluency.vue?macro=true";
import { default as configYrejcNAToOfS9cPFs2rYGyYJadvDwdEv2Fmcfj_4ub4Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/blueprints/config.vue?macro=true";
import { default as feedbackea0wMy13xvZiuKiGE9SgJTDMpVBXrPwsWHgZ_45o2cblYMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/feedback.vue?macro=true";
import { default as api_45testf5G04m79Q9_45NlXTkxgG_45gCR0pyb_45uCoNkYquIodzsH8Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/api-test.vue?macro=true";
import { default as indexzrtfktZp5BitSS5UyKFbnGxECYyvw_45TcYkGqslqjEjUMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/prospecting/index.vue?macro=true";
import { default as billingOzF19huNEuQGki9dUmBOtPbui1O1ev60W0HD34J4bOwMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/reporting/billing.vue?macro=true";
import { default as historyKtNlaOsJ_hxwycvkzoaVHqbwiTZ3BDTaErNZOTIjT98Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/reporting/history.vue?macro=true";
import { default as previewWfj9OJE9xxhLvcpX4BKPo8_45oc_QMjKfDMQqqCNOvr9gMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/reporting/preview.vue?macro=true";
import { default as customersEzGNgwqXeFVxLCSAbXmR9xmdv7twCp2FEjs4ksGIHkMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/settings/customer.vue?macro=true";
import { default as broadcasti4WwmVFPG3g2jbD7O0cl5Wpxz_Owuzm_457PKujrqj8WYMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/customer/broadcast.vue?macro=true";
import { default as prime_45vueuTnvMZz0O64AAOakDDJPG4UMezHU1qp_45qnK7VQdoFmYMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/prime-vue.vue?macro=true";
import { default as crawlerDataiWexRNjg_Fb3IRIiawnT7BM2mG9wmnL6lj74giFS7P8Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/account/crawlerData.vue?macro=true";
import { default as adRenderer_QbIIpy77OYZz7Pq6Oh5s5ZqYx8ySxw4UKmLaY9Zmf0Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/adRenderer.vue?macro=true";
import { default as colab_45test805c6WpXg8lztFwdo3qDy1LR_45UkMs1V3Vy0kWf8C5t0Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/colab-test.vue?macro=true";
import { default as smoke_45testhdt7vZJaDnwdPADiXNX2uN87U6s2iSpJ99NDidwBKkMMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/smoke-test.vue?macro=true";
import { default as chartRenderHpEvW5K_45ZL_cfj3JZ_45Niy_68uU8o_456D2keAWsGYQ2j0Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/chartRender.vue?macro=true";
import { default as drag_45n_45dropHSySVAAG1sVyAkY1lrC0fHAa_4Rm5dyBLJ4mIJWF7hgMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/drag-n-drop.vue?macro=true";
import { default as style_45guide0UeEKHh8kIzmi7hRQd9_45utUDGUufoWR_45VpJjRdEjkdMMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/style-guide.vue?macro=true";
import { default as target_45setsZG1_45pXswjIkHg_458vgnqIvxSLkA2cJ0CZE_IDbwBIo_MMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/settings/target-sets.vue?macro=true";
import { default as tag_45reviewVfjYeFCSu41EIH3QYyrRSQQnXO_DBKoj2u_dcRk_450m4Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/blueprints/tag-review.vue?macro=true";
import { default as reverse_45sync722Pzlq75fSnKljOujfuq3yAJiliGP1zz4U16WO89hMMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/reverse-sync.vue?macro=true";
import { default as dynamic_45formH6Z3rkuxKMfNHIE4Ddl4tJikSwH20DZyn28K6w9sokcMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/dynamic-form.vue?macro=true";
import { default as index_45fBiLPJTxIkTrJN1xvE_MtVEUZgNlxU3FZNn3TssZc8Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/alerts/anomalies/index.vue?macro=true";
import { default as budget_45groupsLVvaxoZctJYapcsIj1R0cowAQehWUP4PclpBuqExUekMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/budget-groups.vue?macro=true";
import { default as peer_45insightsjvOu2Zmm7ua_4ZMKmudnaEiaiER_45415E1nz5IxuGehwMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/peer-insights.vue?macro=true";
import { default as colab_45managerKfmoJyGiF_YnNA4aruf_Y_Upq8eL_7aXscciZffKErYMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/colab-manager.vue?macro=true";
import { default as change_45historyYS0ENXFoUZoXKtZFtFvlsw3R0MHBXmVRfvvFelzp_qwMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/change-history.vue?macro=true";
import { default as blueprint_45demoaHYs9y8F3hEftwz_45Ld_fGXf_45FLM2oax8A4S_45I_dXta0Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/blueprint-demo.vue?macro=true";
import { default as dynamic_45reportSqmRgVDr__452Bq8dc5tEWd8i1DLXF3kb00sEWo6I1hGcMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/dynamic-report.vue?macro=true";
import { default as layout_45builderPtqpsKqd0nox9vOcTumdTC6AtjoDIGc6k46sOadThIgMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/layout-builder.vue?macro=true";
import { default as data_45explorer06uMLtGKTi9Ib3vBDMcmeOcKwyMAfHxfkSIVIUU8L5kMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/reporting/data-explorer.vue?macro=true";
import { default as account_45ingesth0sDph90Ih1gcxIhNwp2jm1vSsrhImVZqsYBAFefgEEMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/settings/account-ingest.vue?macro=true";
import { default as example_45widgetB0cgSMIOaPldINm_4Jv4kgxhC3kBPnyw63NfdFuLkNQMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/dashboard/example-widget.vue?macro=true";
import { default as indexYfPJZzhK00KDp5aJX3ihbRxntlB1o48dwJ5jeaMj8ZEMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/customers/index.vue?macro=true";
import { default as shared_45audiencesaZHd35RJ3UU6RhVe77cfcT9C6QD7AW7tC1VTMfjrGp8Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/settings/shared-audiences.vue?macro=true";
import { default as analyst_45scorecardXXUZ__FYNZoXrH3CVQrKa610F_za0Y53QufUYctRYSoMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/analyst-scorecard.vue?macro=true";
import { default as engineeringAuditCustomerBreakdown2fLvKAIcpAWNyHoWGgmIZcaQWaNI4IIpD2hgaTBSBs0Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/engineering-audit/engineeringAuditCustomerBreakdown.vue?macro=true";
import { default as engineering_45auditwha_AksPN1tU697BgKKcil1PQaztuzIxc4EBA2OFfukMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/engineering-audit.vue?macro=true";
import { default as crawlSiteDetector4FuvyVoThehQKeuA1B_45Z75Xnx_19Mrk7T6j0x2sMCYgMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/settings/crawlSiteDetector.vue?macro=true";
import { default as crawlerDebugBrowservrLgNl7h4Bub_450LTy9QLiBhhRy8_GxEI_8RWVuqrqZEMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/account/crawlerDebugBrowser.vue?macro=true";
import { default as budget_45adjustmentsadsbUQe84bGqepcGDDusgaZtuFLfVsr0VOV2NpRTY3sMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/budget-adjustments.vue?macro=true";
import { default as account_45performancesCxptnxZCoCmaRfUcJ1jI5Z6lVhtDArjmyVmRVDYwTcMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/account-performance.vue?macro=true";
import { default as partner_45sync_45statusc_45SBtpKM4S1_45W4W1tcWch3yY9hSMNOU6bLu7aRcMNJkMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/partner-sync-status.vue?macro=true";
import { default as blueprint_45tag_45languagerVKdWMdlDsbcSINhWBDro0ClrRTc5Th4ELMZQaaCvU0Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/blueprint-tag-language.vue?macro=true";
import { default as keyword_45recommendationsvoINuOo_454DqypjsF4yyp_45TXRHwrh5JZpNjgt0LEw_GEMeta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/keyword-recommendations.vue?macro=true";
import { default as customerPackageSelector_45CjbXnYqHzoMSpZkvQa7F0qbenZl9CsLLSl9gMsEuo4Meta } from "/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/settings/customerPackageSelector.vue?macro=true";
import { default as component_45stubu5AIoxQ6vEMFUv0ekFTL5DvUXFIfP0k1hnZLZAlsJoYMeta } from "/__w/fluent-ui/fluent-ui/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubu5AIoxQ6vEMFUv0ekFTL5DvUXFIfP0k1hnZLZAlsJoY } from "/__w/fluent-ui/fluent-ui/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "labs",
    path: "/labs",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/labs.vue")
  },
  {
    name: "colab",
    path: "/colab",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/colab.vue")
  },
  {
    name: "error",
    path: "/error",
    meta: error4Zpbsjgl7ExNttg2sWsFlwLy3YACKrpogxX5toKXMfkMeta || {},
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/index.vue")
  },
  {
    name: launchaYgv1EPRTpWGVNf_45bCplaFkxNSWMQ_SHIPfDqemXFOQMeta?.name,
    path: "/launch",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/launch.vue"),
    children: [
  {
    name: "launch",
    path: "",
    meta: indexLc9YtEJzuTKvv_45xDLrZbroQM3dwpCARbDjpQAV22C8UMeta || {},
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/launch/index.vue")
  },
  {
    name: "launch-status",
    path: "status",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/launch/status/index.vue")
  },
  {
    name: "launch-quick-launch-status",
    path: "quick-launch-status",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/launch/quick-launch-status.vue")
  }
]
  },
  {
    name: managezGi5ibVWesTfZVY4zCxLDns84yRHayjR4vad_qP_4_sMeta?.name,
    path: "/manage",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/manage.vue"),
    children: [
  {
    name: "manage",
    path: "",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/manage/index.vue")
  },
  {
    name: "manage-manageType",
    path: ":manageType()",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/manage/[manageType].vue")
  },
  {
    name: "manage-create",
    path: "create",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/manage/create/index.vue")
  }
]
  },
  {
    name: "status",
    path: "/status",
    meta: statusP2dOHP82RMarFDYG2gOwJvObPgUcZqAPVQGd0FyymhgMeta || {},
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/status.vue")
  },
  {
    name: "api-doc",
    path: "/api-doc",
    meta: api_45docPaB_2WgNauZeMMQ6HUZqoKcLOW33c8Py0iQe2N0X4GoMeta || {},
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/api-doc.vue")
  },
  {
    name: welcomelnDrnErmADE3pBo6pEF2f1bXKDuA_BWfbr9tbDUN3BgMeta?.name,
    path: "/welcome",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/welcome.vue"),
    children: [
  {
    name: "welcome",
    path: "",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/welcome/index.vue")
  }
]
  },
  {
    name: "bulk-edit",
    path: "/bulk-edit",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/bulk-edit.vue")
  },
  {
    name: "html5-ads",
    path: "/html5-ads",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/html5-ads.vue")
  },
  {
    name: "video-ads",
    path: "/video-ads",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/video-ads.vue")
  },
  {
    name: "bulk",
    path: "/bulk",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/bulk/index.vue")
  },
  {
    name: "deckHelper",
    path: "/deckHelper",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/deckHelper.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexBrQhsGRqSKY1JhZGNlpQLKB7eu6QVMunpEk14qmqqekMeta || {},
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/login/index.vue")
  },
  {
    name: "office-mate",
    path: "/office-mate",
    meta: office_45matelMCNXPc0vfJStKxSed5YOydCkk26YeZcRQwLWNjGx4kMeta || {},
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/office-mate.vue")
  },
  {
    name: "setup",
    path: "/setup",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/setup/index.vue")
  },
  {
    name: "style",
    path: "/style",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/style/index.vue")
  },
  {
    name: "alerts",
    path: "/alerts",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/alerts/index.vue")
  },
  {
    name: "bionic",
    path: "/bionic",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/bionic/index.vue")
  },
  {
    name: "bulk-receipt",
    path: "/bulk/receipt",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/bulk/receipt.vue")
  },
  {
    name: "form-designer",
    path: "/form-designer",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/form-designer.vue")
  },
  {
    name: "insights-logs",
    path: "/insights/logs",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/logs.vue")
  },
  {
    name: "internal-logo",
    path: "/internal/logo",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/logo.vue")
  },
  {
    name: "internal-vue3",
    path: "/internal/vue3",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/vue3.vue")
  },
  {
    name: "settings-data",
    path: "/settings/data",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/settings/data.vue")
  },
  {
    name: "bionic-bionic2",
    path: "/bionic/bionic2",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/bionic/bionic2.vue")
  },
  {
    name: "bionic-bionic3",
    path: "/bionic/bionic3",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/bionic/bionic3.vue")
  },
  {
    name: "bionic-bionic4",
    path: "/bionic/bionic4",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/bionic/bionic4.vue")
  },
  {
    name: "internal",
    path: "/internal",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/index.vue")
  },
  {
    name: "page-not-found",
    path: "/page-not-found",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/page-not-found.vue")
  },
  {
    name: "approvals",
    path: "/approvals",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/approvals/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/dashboard/index.vue")
  },
  {
    name: "reporting",
    path: "/reporting",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/reporting/index.vue")
  },
  {
    name: "setup-partner",
    path: "/setup/:partner()",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/setup/[partner].vue")
  },
  {
    name: "blueprints",
    path: "/blueprints",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/blueprints/index.vue")
  },
  {
    name: "insights-crawler",
    path: "/insights/crawler",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/crawler.vue")
  },
  {
    name: "internal-ai-help",
    path: "/internal/ai-help",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/ai-help.vue")
  },
  {
    name: "internal-sandbox",
    path: "/internal/sandbox",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/sandbox.vue")
  },
  {
    name: "settings-fluency",
    path: "/settings/fluency",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/settings/fluency.vue")
  },
  {
    name: "blueprints-config",
    path: "/blueprints/config",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/blueprints/config.vue")
  },
  {
    name: "insights-feedback",
    path: "/insights/feedback",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/feedback.vue")
  },
  {
    name: "internal-api-test",
    path: "/internal/api-test",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/api-test.vue")
  },
  {
    name: "prospecting",
    path: "/prospecting",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/prospecting/index.vue")
  },
  {
    name: "reporting-billing",
    path: "/reporting/billing",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/reporting/billing.vue")
  },
  {
    name: "reporting-history",
    path: "/reporting/history",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/reporting/history.vue")
  },
  {
    name: "reporting-preview",
    path: "/reporting/preview",
    meta: previewWfj9OJE9xxhLvcpX4BKPo8_45oc_QMjKfDMQqqCNOvr9gMeta || {},
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/reporting/preview.vue")
  },
  {
    name: "settings-customer",
    path: "/settings/customer",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/settings/customer.vue")
  },
  {
    name: "customer-broadcast",
    path: "/customer/broadcast",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/customer/broadcast.vue")
  },
  {
    name: "internal-prime-vue",
    path: "/internal/prime-vue",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/prime-vue.vue")
  },
  {
    name: "account-crawlerData",
    path: "/account/crawlerData",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/account/crawlerData.vue")
  },
  {
    name: "internal-adRenderer",
    path: "/internal/adRenderer",
    meta: adRenderer_QbIIpy77OYZz7Pq6Oh5s5ZqYx8ySxw4UKmLaY9Zmf0Meta || {},
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/adRenderer.vue")
  },
  {
    name: "internal-colab-test",
    path: "/internal/colab-test",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/colab-test.vue")
  },
  {
    name: "internal-smoke-test",
    path: "/internal/smoke-test",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/smoke-test.vue")
  },
  {
    name: "internal-chartRender",
    path: "/internal/chartRender",
    meta: chartRenderHpEvW5K_45ZL_cfj3JZ_45Niy_68uU8o_456D2keAWsGYQ2j0Meta || {},
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/chartRender.vue")
  },
  {
    name: "internal-drag-n-drop",
    path: "/internal/drag-n-drop",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/drag-n-drop.vue")
  },
  {
    name: "internal-style-guide",
    path: "/internal/style-guide",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/style-guide.vue")
  },
  {
    name: "settings-target-sets",
    path: "/settings/target-sets",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/settings/target-sets.vue")
  },
  {
    name: "blueprints-tag-review",
    path: "/blueprints/tag-review",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/blueprints/tag-review.vue")
  },
  {
    name: "insights-reverse-sync",
    path: "/insights/reverse-sync",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/reverse-sync.vue")
  },
  {
    name: "internal-dynamic-form",
    path: "/internal/dynamic-form",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/dynamic-form.vue")
  },
  {
    name: "alerts-anomalies",
    path: "/alerts/anomalies",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/alerts/anomalies/index.vue")
  },
  {
    name: "insights-budget-groups",
    path: "/insights/budget-groups",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/budget-groups.vue")
  },
  {
    name: "insights-peer-insights",
    path: "/insights/peer-insights",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/peer-insights.vue")
  },
  {
    name: "internal-colab-manager",
    path: "/internal/colab-manager",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/colab-manager.vue")
  },
  {
    name: "insights-change-history",
    path: "/insights/change-history",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/change-history.vue")
  },
  {
    name: "internal-blueprint-demo",
    path: "/internal/blueprint-demo",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/blueprint-demo.vue")
  },
  {
    name: "internal-dynamic-report",
    path: "/internal/dynamic-report",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/dynamic-report.vue")
  },
  {
    name: "internal-layout-builder",
    path: "/internal/layout-builder",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/layout-builder.vue")
  },
  {
    name: "reporting-data-explorer",
    path: "/reporting/data-explorer",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/reporting/data-explorer.vue")
  },
  {
    name: "settings-account-ingest",
    path: "/settings/account-ingest",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/settings/account-ingest.vue")
  },
  {
    name: "dashboard-example-widget",
    path: "/dashboard/example-widget",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/dashboard/example-widget.vue")
  },
  {
    name: "internal-customers",
    path: "/internal/customers",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/customers/index.vue")
  },
  {
    name: "settings-shared-audiences",
    path: "/settings/shared-audiences",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/settings/shared-audiences.vue")
  },
  {
    name: "insights-analyst-scorecard",
    path: "/insights/analyst-scorecard",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/analyst-scorecard.vue")
  },
  {
    name: "internal-engineering-audit",
    path: "/internal/engineering-audit",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/engineering-audit.vue"),
    children: [
  {
    name: "internal-engineering-audit-engineeringAuditCustomerBreakdown",
    path: "engineeringAuditCustomerBreakdown",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/engineering-audit/engineeringAuditCustomerBreakdown.vue")
  }
]
  },
  {
    name: "settings-crawlSiteDetector",
    path: "/settings/crawlSiteDetector",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/settings/crawlSiteDetector.vue")
  },
  {
    name: "account-crawlerDebugBrowser",
    path: "/account/crawlerDebugBrowser",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/account/crawlerDebugBrowser.vue")
  },
  {
    name: "insights-budget-adjustments",
    path: "/insights/budget-adjustments",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/budget-adjustments.vue")
  },
  {
    name: "insights-account-performance",
    path: "/insights/account-performance",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/account-performance.vue")
  },
  {
    name: "insights-partner-sync-status",
    path: "/insights/partner-sync-status",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/partner-sync-status.vue")
  },
  {
    name: "internal-blueprint-tag-language",
    path: "/internal/blueprint-tag-language",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/internal/blueprint-tag-language.vue")
  },
  {
    name: "insights-keyword-recommendations",
    path: "/insights/keyword-recommendations",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/insights/keyword-recommendations.vue")
  },
  {
    name: "settings-customerPackageSelector",
    path: "/settings/customerPackageSelector",
    component: () => import("/__w/fluent-ui/fluent-ui/apps/backpack/src/pages/settings/customerPackageSelector.vue")
  },
  {
    name: component_45stubu5AIoxQ6vEMFUv0ekFTL5DvUXFIfP0k1hnZLZAlsJoYMeta?.name,
    path: "/setup/start",
    component: component_45stubu5AIoxQ6vEMFUv0ekFTL5DvUXFIfP0k1hnZLZAlsJoY
  },
  {
    name: component_45stubu5AIoxQ6vEMFUv0ekFTL5DvUXFIfP0k1hnZLZAlsJoYMeta?.name,
    path: "/setup/connect",
    component: component_45stubu5AIoxQ6vEMFUv0ekFTL5DvUXFIfP0k1hnZLZAlsJoY
  },
  {
    name: component_45stubu5AIoxQ6vEMFUv0ekFTL5DvUXFIfP0k1hnZLZAlsJoYMeta?.name,
    path: "/setup/csv",
    component: component_45stubu5AIoxQ6vEMFUv0ekFTL5DvUXFIfP0k1hnZLZAlsJoY
  }
]